import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ServerResponse } from '../models/types';
import { JWTService } from './JWT.service';
import { Router } from '@angular/router';
import { StallsService } from './stalls.service';

@Injectable()
export class SigninService {
url: string;

constructor(
    private http: HttpClient,
    private stallsService: StallsService,
    private jwtService: JWTService,
    private router: Router,
    @Inject('BASE_URL') baseUrl: string,
) {
    this.url = baseUrl;
}

  async loginUser(username: string, password: string, mach:string ="") {
    let MACH_TT = '';
    if (mach == '0000') {
      await this.stallsService.getHQ().then(x => MACH_TT = x);
      await localStorage.setItem('_maCHTT', MACH_TT);
    }
    else {
      MACH_TT = mach;
    }
    const data = {
      'username': username,
      'password': password,
      'mach': MACH_TT,
    };
    const jwt = await this.jwtService.Encode(data);
    return await this.http.post(this.url + 'api/Auth/LoginAdmin',
    { TokenCL: jwt })
    .toPromise()
    .then((result: ServerResponse) => {
      if (result[0].code === 1) {
        return this.jwtService.Decode(result[0].data)
        .then (res => {
          localStorage.setItem('_user', JSON.stringify(res));
          this.router.navigate(['/pages/iot-dashboard']).then(() => {
            window.location.reload();
          });
        });
      } else if (result[0].code === 0) {
        throw new Error(result[0].message);
      }
    });
  }

  checkUID(uid: string){
    return this.http.post(`${this.url}api/Auth/getAccess`, {
      UID: uid,
    }).toPromise()
    .then(result => {
      if (result === false) {
        this.http.get('manifest.json', { responseType: 'json' }).subscribe( async name => {
          const urlTPC: string = await name['config_topos'];
          window.location.href = urlTPC;
        });
        return false;
      } else {
        return true;
      }
    });
  }


}
